import { AxiosRequestConfig, AxiosResponse } from "axios";
import { toastError, toastSuccess } from "./Toasts";
import { logOutWithNextUrl } from "../repositories/PredsenseRepository";

export const checkToken = (
  config: AxiosRequestConfig,
  token: string,
  setIsSessionExpired: (value: boolean) => void,
  callback: () => void
) => {
  if (config.url === "/auth/login") {
    return config;
  } else if (token !== null) {
    // const tokenDecoded = jwtDecode<any>(token);
    // Logout user if token expired more then 4 hours ago
    // if ((Date.now() - tokenDecoded.exp * 1000) / 3600000 > 0.04) {
    //   return logOutWithNextUrl();
    // }
    // Show popup if token expired
    // else if (Date.now() > tokenDecoded.exp * 1000) {
    //   return setIsSessionExpired(true);
    // } else {
    return callback();
    // }
  } else logOutWithNextUrl();
};

export const axiosResponseHandler = (data: AxiosResponse) => {
  if (
    ["post", "patch"].includes(data?.config.method || "") &&
    !data?.config.headers?.noToast
  )
    toastSuccess();
  else if (data?.config.method === "delete")
    toastSuccess("Deleted Successfully");
  return data;
};

export const axiosErrorHandler = (error: any) => {
  if (!navigator.onLine || error.message === "Network Error") {
    toastError(
      "No internet connection. Please check your internet connection."
    );
    return Promise.reject(error);
  }

  if (error.response?.status === 401 && window.location.pathname !== "/login") {
    logOutWithNextUrl();
  } else if (error.response?.status === 401) {
    return Promise.reject(error);
  } else if (!error.config?.headers?.noToast) {
    toastError(
      error.response?.data?.detail ||
        error.response?.data ||
        "An error occurred"
    );
  }
  return Promise.reject(error);
};
